'use client';

import { Box, Grid, GridItem, Typography } from '@coolblue-development/freddy';
import useTestId from '@hooks/useTestId';
import { useTranslation } from '@i18n/useTranslation';

import type { InsuranceInformationProps } from '../types';
import CoveragesBlock from './CoveragesBlock';
import PackagesBlock from './PackagesBlock';

export default function Information({ product, insurance, urls }: InsuranceInformationProps) {
  const { t } = useTranslation('webshop.productPage.insurance');
  const testId = useTestId('insurance-block-be');

  const productTypeName = product.productType.singularName;

  if (!insurance) {
    return null;
  }

  return (
    <Box {...testId}>
      <Typography variant='h2' mb={0} overflowWrap='normal'>
        {t('title', { productType: productTypeName })}
      </Typography>
      <Typography mb={0}>{insurance.description}</Typography>
      <Grid
        mt={500}
        columnGap={400}
        rowGap={400}
        templateColumns={{
          xs: '1fr',
          lg: '1fr 1fr'
        }}
        templateAreas={{
          xs: `
          "packages"
          "coverages"
        `,
          lg: `"coverages packages"`
        }}
      >
        <GridItem area='coverages'>
          <CoveragesBlock
            insurance={insurance}
            termsConditionsUrl={urls.insuranceTermsConditionsUrl}
            insuranceCardUrl={insurance.documents?.insuranceCardUrl || ''}
            customerServiceUrl={urls.customerServiceUrl}
            moreInformationUrl={urls.insuranceMoreInformationUrl}
          />
        </GridItem>
        <GridItem area='packages'>
          <PackagesBlock
            insurance={insurance}
            productType={productTypeName}
            primaryProductId={product.id}
            primaryProductImageId={String(product.primaryImage.id)}
            primaryProductName={product.name}
          />
        </GridItem>
      </Grid>
    </Box>
  );
}
